import { render, staticRenderFns } from "./1439_有序矩阵中的第k个最小数组和.md?vue&type=template&id=7f76702c&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports